import { ControllerButton, useControllerButtonIcons } from '@/lib/hotkey-context';

interface ControllerIconProps {
    button: ControllerButton;
    className?: string;
}

export function ControllerIcon({ button, className = '' }: ControllerIconProps) {
    const CONTROLLER_BUTTON_ICONS = useControllerButtonIcons();
    const iconPath = CONTROLLER_BUTTON_ICONS[button];
    const baseClass = 'inline-block pointer-events-none ' + className;

    return (
        <img
            src={iconPath}
            alt={`${button} button`}
            width={24}
            height={24}
            className={baseClass}
        />
    );
} 